module.exports = __webpack_public_path__ + "media/7.06e23635.mp3";